import { Popover } from "flowbite-react";
import { FaInfoCircle } from "react-icons/fa";

type CardIRFWeeklyProps = {
  label: string;
  value?: number;
};

const CardIRFWeekly = (props: CardIRFWeeklyProps) => (
  <div
    className={`${(props.value ?? 0) > 5
      ? 'bg-green-500 text-white'
      : (props.value ?? 0) >= 3
        ? 'bg-yellow-500 text-white'
        : (props.value ?? 0) >= 1
          ? 'bg-orange-500 text-white'
          : 'bg-red-500 text-white'}
                  relative border border-gray-300 shadow-md rounded-2xl p-5 transition hover:shadow-lg hover:scale-[1.01] animate-pulse font-semibold`}
    id="card-ifr-semanal"
  >
    <div className="grid grid-cols-[1fr_auto] gap-4 items-center justify-center">
      <div className="flex flex-col justify-center  items-center">
        <div className="mb-2 flex items-center gap-2">
          <h3 className={`text-xl font-semibold`}>
            IFR (Semanal)
          </h3>
          <Popover
            content={
              <div className="text-black border border-gray-300 rounded-md shadow-md p-2 max-w-sm relative z-40">
                <span className="text-sm">{`Total de Motos Locadas / Total de Motos Recolhidas na Semana`}</span>
              </div>
            }
            placement="top"
            trigger="click"
          >
            <div className="cursor-pointer text-white" role="button-operational-management-group">
              <FaInfoCircle className="text-white" />
            </div>
          </Popover>
        </div>
        <p className={`text-3xl font-semibold`}>
          1 / {(props.value?.toFixed(2) ?? "0").replace(".", ",")}
        </p>
      </div>
    </div>
  </div>

);

export default CardIRFWeekly;
